import {gql} from 'apollo-angular';

export const GET_ROOKIE_DAY_CONTACT_APPOINTMENTS = gql`
  query GetRookieDayContactAppointments($code: String!, $verifyCode: String!) {
    rookiedayContactAppointments(code: $code, verifyCode: $verifyCode) {
      startAt
      endAt
      eventDateId
      eventDate
      timeSlotId
      timeSlotMappingId
      jobName
      schoolName
      studentId
      studentAttendanceState
      studentFirstname
      studentLastname
      isCancelled
    }
  }
`;
